import type { z } from 'zod';

import { createVersionedFeature } from '../create-versioned-feature';
import { scrollEffectV0Schema } from './v0';

/**
 * What the background does as the page scrolls.
 *
 * The **column**'s only, and flat, because that is what the data says: legacy's
 * per-device column bag (`columnDeviceDataSchemaLegacy`) carries the background,
 * the contour and the two overlays but never a scroll effect.
 *
 * A **block** has one too, and it is *not* this: its legacy bags write the effect
 * per breakpoint, so it stays a responsive pair inside `background`. Two shapes
 * that differ in what they can express are two things, however alike they read.
 */
export const scrollEffectFeature = createVersionedFeature({
    versionMap: {
        0: { schema: scrollEffectV0Schema },
    },
    latestVersion: 0,
    createDefault: (): z.output<typeof scrollEffectV0Schema> => ({
        version: 0,
        isEnabled: false,
        value: '',
    }),
});

export type ScrollEffectSettings = z.output<typeof scrollEffectFeature.latestSchema>;

export { scrollEffectV0Schema };

export { scrollEffectMode } from './scroll-effect.css-vars';
export type { ScrollEffectMode } from './scroll-effect.css-vars';
